import { render, staticRenderFns } from "./CbrAccountsActions.vue?vue&type=template&id=8005985e&lang=pug&"
import script from "./CbrAccountsActions.vue?vue&type=script&lang=js&"
export * from "./CbrAccountsActions.vue?vue&type=script&lang=js&"
import style0 from "./CbrAccountsActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports